module.exports = __webpack_public_path__ + "static/img/cont34 (3).b9a2b2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (3).jpg
// module id = XcWZ
// module chunks = 0